export const width = 873;
export const height = 565;
export const duration = 4000;
export const duration2 = 1150;
